 <template>
	<div class="dialog">
        <div class="dialog-block">
            <button class="close-btn" @click="closeWindow">&times;</button>

            <div>
                <div>
                    <button class="btn btn-all btn-green" @click="skanuj_kod">
                        <span><camera-icon class="icon"></camera-icon></span>
                        {{ translation.skanuj_kod_aparatem }}
                    </button>
                    <button class="btn btn-all btn-green" @click="wpiszKod">
                        <span><pencil-square-icon class="icon"></pencil-square-icon></span>
                        {{ translation.wpisz_kod_recznie }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import de from '../locale/de.js';
import en from '../locale/en.js';
import es from '../locale/es.js';
import fr from '../locale/fr.js';
import it from '../locale/it.js';
import pl from '../locale/pl.js';
import pt from '../locale/pt.js';
import { CameraIcon, PencilSquareIcon } from '@heroicons/vue/24/solid';

export default {
    name: 'JakDolaczyc',
    props: {
        language: String
    },
    components: {
        CameraIcon,
        PencilSquareIcon
    },
    data() {
        return {
            lang: localStorage.getItem('language'),
            translation: pl,
            theme: localStorage.getItem('theme'),
        }
    },
    beforeMount() {
        switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }
    },
    methods: {
        closeWindow() {
            console.log('click button')
            //this.$emit('close-event-listener');
            //this.$parent.spinner = true;
            this.$parent.jak_dolaczyc = false
            this.$parent.blured = false
            this.$parent.lang = this.lang
        },
        setlanguage(el) {
            localStorage.setItem('language', el)
            this.lang = el;
            this.$parent.lang = el;

            switch(this.lang)
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }
        },
        changeTheme(el) {
            localStorage.setItem('theme', el)
            this.theme = el;
            this.$parent.mode = el
        },
        wpiszKod() {
            this.$parent.jak_dolaczyc = false
            this.$parent.blured = false
            this.$parent.plansza = 'gracz2-kod';
        },
        skanuj_kod() {
            this.$parent.jak_dolaczyc = false
            this.$parent.blured = false
            this.$parent.plansza = 'gracz2-scan';
        }
    },
     watch: {
        language(l) {
            this.lang = l;
            switch(localStorage.getItem('language'))
            {
                case 'de':
                    this.translation = de;
                    break;
                case 'en':
                    this.translation = en;
                    break;
                case 'es':
                    this.translation = es;
                    break;
                case 'fr':
                    this.translation = fr;
                    break;
                case 'it':
                    this.translation = it;
                    break;
                case 'pt':
                    this.translation = pt;
                    break;
                default:
                    this.translation = pl;
                    break;
            }

        }
     }
}
</script>

<style scoped>
.dialog {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    /* width: 80vw; */
    margin: 5vw;
    padding: 3vw;
    z-index: 200;
    border-radius:10px;
    background-color:var(--bs-gray-settings);
    -webkit-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    -moz-box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
    box-shadow: 0px 0px 24px 0px rgba(66, 68, 90, 1);
}
.dialog-block {
    width:95%;
}

.btn-all span {
    height: 50px;
    position:relative;
    padding: 1em 0;
    display:block;
    text-align:center;
    animation: chevronPulse 1s infinite;
}
.btn-all span svg {
    width:50px;
}

.close-btn {
    position: absolute;
    top: 15px;
    right: 15px;
    background: none;
    border: none;
    font-size: 30px;
    color: var(--bs-settings-button-color);
    cursor: pointer;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
}

.btn.btn-all {
    font-size: 1em;
    width: 100%;
    border-radius: 10px;
    margin: 50px auto 10px;
    font-weight:bold;
    position: relative;
    padding-bottom:1em;
}
button.btn {
    font-size: 1em;
    font-family: 'Jost', sans-serif;
}
.btn-green {
    background-color: transparent;
    color: var(--bs-button-text);
    position: relative;
    border: 3px solid var(--bs-gradient-to);
}



@keyframes chevronPulse {
    0%, 100% {
        transform: translateY(2px)  translateX(0);
        opacity: 1;
    }
    50% {
        transform: translateY(-2px)  translateX(2px);
        opacity: 0.5;
    }
}

</style>
